// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3DSYi","errorLogs":"styles_errorLogs__2vQVs"};